import axios from 'axios'
import { store } from '@/store/store'
import config from '@/config'

const instance = () => {
  return axios.create({
    baseURL: `${config.serverUrl}`,
    timeout: 30000,
    headers: {
      AUTHORIZATION: store.getters.securityToken
    }
  })
}

const cmsConfig = {
  updatePageCustomAttributes: (request) => {
    const { params, data } = request
    return instance().post(`/api/cms/v1/page/${params.pageId}/page-custom-attributes`, data)
  }
}

export default cmsConfig



// WEBPACK FOOTER //
// ./src/api/config.js